import { useCallback } from "react"
import { useSetState } from "ahooks"
import { createModel } from "hox"

type stateVO = {
  activeReportId?: string
}

function useRegionInsightReport() {
  const [state, setState] = useSetState<stateVO>({
    activeReportId: "",
  })

  const setReportId = useCallback(
    (reportId?: string) => {
      setState({
        activeReportId: reportId,
      })
    },
    [setState],
  )

  return {
    ...state,
    setReportId,
  }
}

export default createModel(useRegionInsightReport)
